import {
  FacebookLogo,
  InstagramLogo,
  XLogo,
  LinkedinLogo,
  YoutubeLogo,
  TiktokLogo,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { useLang } from "@/lib/LangContext";
import { SOCIAL_LINKS } from "@/lib/i18n";
import { LogoLockup } from "@/components/Logo";

const socials = [
  { key: "facebook", Icon: FacebookLogo, url: SOCIAL_LINKS.facebook },
  { key: "instagram", Icon: InstagramLogo, url: SOCIAL_LINKS.instagram },
  { key: "twitter", Icon: XLogo, url: SOCIAL_LINKS.twitter },
  { key: "linkedin", Icon: LinkedinLogo, url: SOCIAL_LINKS.linkedin },
  { key: "youtube", Icon: YoutubeLogo, url: SOCIAL_LINKS.youtube },
  { key: "tiktok", Icon: TiktokLogo, url: SOCIAL_LINKS.tiktok },
  { key: "whatsapp", Icon: WhatsappLogo, url: SOCIAL_LINKS.whatsapp },
];

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="relative pt-24 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-6">
            <div className="mb-4">
              <LogoLockup size={32} />
            </div>
            <p className="font-mono-x text-sm text-slate-400 max-w-md leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>
          <div className="md:col-span-6">
            <div className="font-mono-x text-[10px] tracking-[0.3em] uppercase text-slate-500 mb-4">
              // SOCIAL
            </div>
            <div className="flex flex-wrap gap-3">
              {socials.map((s) => (
                <a
                  key={s.key}
                  data-testid={`social-${s.key}`}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.key}
                  className="w-11 h-11 border border-white/10 flex items-center justify-center text-slate-300 hover:border-brand-500 hover:text-brand-500 transition-colors duration-200"
                >
                  <s.Icon size={18} weight="regular" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Massive typography */}
        <div className="py-16 flex justify-center">
          <div
            className="font-display font-medium tracking-tighter text-brand-500/[0.08] leading-none select-none"
            style={{ fontSize: "clamp(3rem, 15vw, 15rem)" }}
          >
            rio-code
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 font-mono-x text-[10px] uppercase tracking-[0.25em] text-slate-500">
          <div>© {year} RIO CODE · {t.footer.rights}</div>
          <div className="flex gap-6">
            <span>v1.0.0</span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-brand-500 rounded-full animate-pulse" />
              STATUS: OPERATIONAL
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
